import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import useClasses from '../../../hooks/legacy/useClasses';
import QuestionRadioForm from '../../input/QuestionRadioForm/QuestionRadioForm';
import QuestionCheckboxForm from '../../input/QuestionCheckboxForm/QuestionCheckboxForm';

import styles from './AddToCartPanel.style';

function MenuItemQuestions({ menuItem, onChange, orderType, selectedOptions }) {
  const classes = useClasses(styles);

  const { answers, questions } = menuItem;

  // Memoize the sorted answers
  const sortedAnswers = useMemo(
    () => [...answers].sort((a, b) => a.sort - b.sort),
    [answers]
  );

  // Memoize the sorted questions
  const sortedQuestions = useMemo(
    () => [...questions].sort((a, b) => a.order - b.order),
    [questions]
  );

  const questionsWithSub = useMemo(
    () =>
      sortedQuestions.filter((question) => {
        if (!question.sub) {
          return true;
        }

        return !!selectedOptions.find((option) => option.child === question.id);
      }),
    [sortedQuestions, selectedOptions]
  );

  return (
    <div className={classes.questionsGroup}>
      {questionsWithSub?.map((question) => {
        const answersPerQuestion = sortedAnswers.filter(
          (answer) => answer.parent === question.id
        );

        const QuestionForm =
          question.format === 'radio'
            ? QuestionRadioForm
            : QuestionCheckboxForm;

        return (
          <QuestionForm
            key={question.id}
            type={orderType}
            onChange={onChange}
            question={question}
            data-test-id="q-radio-form"
            answers={answersPerQuestion}
            selectedOptions={selectedOptions}
          />
        );
      })}
    </div>
  );
}

MenuItemQuestions.propTypes = {
  menuItem: PropTypes.shape({
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        child: PropTypes.string,
        id: PropTypes.string,
        parent: PropTypes.string,
        sort: PropTypes.number,
        text: PropTypes.string,
        prices: PropTypes.arrayOf(
          PropTypes.shape({
            service: PropTypes.string,
            price: PropTypes.number,
          })
        ),
      })
    ),
    category: PropTypes.number,
    description: PropTypes.string,
    id: PropTypes.string,
    media: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
      PropTypes.array,
    ]),
    meta_category: PropTypes.number,
    name: PropTypes.string,
    preparation: PropTypes.number,
    prices: PropTypes.shape({
      delivery: PropTypes.number,
      takeout: PropTypes.number,
      catering: PropTypes.number,
    }),
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        order: PropTypes.number,
        required: PropTypes.bool,
        sub: PropTypes.bool,
        text: PropTypes.string,
        num_free: PropTypes.number,
        min: PropTypes.number,
        max: PropTypes.number,
        max_per_answer: PropTypes.number,
      })
    ),
    service: PropTypes.arrayOf(PropTypes.string),
    sort: PropTypes.number,
    tax: PropTypes.number,
    tree: PropTypes.oneOfType([
      PropTypes.objectOf(PropTypes.any),
      PropTypes.arrayOf(PropTypes.any),
    ]),
    type: PropTypes.string,
  }).isRequired,
  selectedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      order: PropTypes.number,
      parentId: PropTypes.string,
      quantity: PropTypes.number,
      sort: PropTypes.number,
      specialInstructions: PropTypes.string,
      weight: PropTypes.number,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  orderType: PropTypes.shape({
    label: PropTypes.string,
    text: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
};

export default MenuItemQuestions;
